import React from "react"
import "./layout.css"

const Layout = ({ children }) => <main>{children}</main>

export default Layout
